const counterApi = [
  {
    icon: "flaticon-project-management-1",
    count: 5,
    label: "Project Completed",
  },
  {
    icon: "flaticon-rating-1",
    count: 1,
    label: "Team Member",
  },
  {
    icon: "flaticon-expert",
    count: 1,
    label: "Awards Winning",
  },
  {
    icon: "flaticon-rating",
    count: 10,
    label: "Happy Customer",
  },
];
export default counterApi;
